import React from 'react';
import './MainBody.scss';

interface MainBodyProps {
  children: React.ReactNode;
}

const MainBody: React.FC<MainBodyProps> = ({ children }) => (
  <main className="main-body">
    {children}
  </main>
);

export default MainBody;
